import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const NoNetworkIcon = ({tintColor = '#fff', ...props}) => {
  return (
    <Svg
      width={59}
      height={59}
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M29.5 49.781a3.687 3.687 0 100-7.375 3.687 3.687 0 000 7.375z"
        fill={tintColor}
      />
      <Path
        d="M55.313 6.295l-2.608-2.607L3.688 52.705l2.607 2.608 19.694-19.695A10.944 10.944 0 0137.07 38.05l2.608-2.607a14.689 14.689 0 00-9.45-4.063l6.247-6.247a22.106 22.106 0 018.415 5.098l2.605-2.607a25.766 25.766 0 00-8.16-5.352l5.525-5.526a33.072 33.072 0 017.844 5.67l2.608-2.61v-.003a36.918 36.918 0 00-7.725-5.786l7.725-7.723zM27.066 24.113l3.765-3.765c-.446-.024-.883-.067-1.331-.067a25.712 25.712 0 00-18.015 7.362l2.607 2.606a22.069 22.069 0 0112.974-6.136zM29.5 12.906c2.63.01 5.25.335 7.803.968l3.029-3.027a36.79 36.79 0 00-36.645 8.955v.042l2.59 2.589A33.04 33.04 0 0129.5 12.906z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default NoNetworkIcon;
